module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aleg3-28736e259b56e1e32e794f511d6cb051.jpg";